import { render, staticRenderFns } from "./AdminBuilderScreen.vue?vue&type=template&id=2cda4ac3&scoped=true"
import script from "./AdminBuilderScreen.vue?vue&type=script&lang=js"
export * from "./AdminBuilderScreen.vue?vue&type=script&lang=js"
import style0 from "./AdminBuilderScreen.vue?vue&type=style&index=0&id=2cda4ac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda4ac3",
  null
  
)

export default component.exports